// extracted by css-extract-rspack-plugin
export default {"taskStateLabel":"taskStateLabel-db_aXf","taskStateButton":"taskStateButton-jJOlb6"};